import { render, staticRenderFns } from "./getTimeUnLock.vue?vue&type=template&id=0fedf507&scoped=true&"
import script from "./getTimeUnLock.vue?vue&type=script&lang=js&"
export * from "./getTimeUnLock.vue?vue&type=script&lang=js&"
import style0 from "./getTimeUnLock.vue?vue&type=style&index=0&id=0fedf507&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fedf507",
  null
  
)

export default component.exports